export const NONE = {
  id: 'none',
  label: 'Nessuno',
};

export const MIDWIFE = {
  id: 'midwife',
  label: 'Ostetrica/o',
};

export const GYNECOLOGIST = {
  id: 'gynecologist',
  label: 'Ostetrico-ginecologo/a',
};

export const NEONATOLOGIST = {
  id: 'neonatologist',
  label: 'Pediatra-neonatologo',
};

export const ANESTHETIST = {
  id: 'anesthetist',
  label: 'Anestesista',
};

export const NURSE = {
  id: 'nurse',
  label: 'Infermiera/e neonatale',
};

export const OTHER_HCP = {
  id: 'other',
  label: 'Altro personale sanitario o tecnico',
};
